import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, DoCheck, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { AutoComplete } from "primeng/autocomplete";
import { SubSink } from "subsink";
import { ArrayHelper } from "../../../utilities/contracts/array-helper";
import { DynamicControlDirective } from "../../dynamic-control-component.model";
import { FormService } from "../../form.service";
import { SelectableInput } from "../selectable-input.model";
import { TagSearchAutoComplete } from "./tag-search.model";

@Component({
  selector: "form-tag-search-autocomplete",
  templateUrl: "./tag-search-autocomplete.component.html",
  styleUrls: ["./tag-search-autocomplete.component.scss",
              "../autocomplete/autocomplete.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TagSearchAutoCompleteComponent extends DynamicControlDirective<TagSearchAutoComplete> implements OnInit, AfterViewInit, OnDestroy, DoCheck {

  private sink = new SubSink();
  filteredOptions: SelectableInput[] = [];
  @ViewChild(AutoComplete, { static: true }) primeAutocomplete: AutoComplete;


  constructor(
    private readonly changeDetector: ChangeDetectorRef,
    private readonly formService: FormService
  ) {
    super();
  }

  ngOnInit() {
    this.sink.add(
      this.control.statusChanges.subscribe(() => this.formService.updateDom.next()),
      this.formService.updateDom.subscribe(() => this.changeDetector.markForCheck())
    );
  }

  ngOnDestroy() {
    this.sink.unsubscribe();
  }

  ngAfterViewInit() {
    if (this.primeAutocomplete.dropdownButton != null) {
      this.primeAutocomplete.dropdownButton.nativeElement.tabIndex = -1;
    }

    if (this.model.hasServerFilter) {
      this.filterOptions({ query: this.model.value });
    }
  }

  ngDoCheck() {
    if (this.filteredOptions !== this.model.options) {
      this.filteredOptions = this.model.options;
      this.changeDetector.markForCheck();
    }
  }

  get classes(): any {
    return this.getClasses("autocomplete");
  }

  get hasOptions(): boolean {
    return this.model.hasServerFilter || ArrayHelper.isAvailable(this.model.options);
  }

  filterOptions(event): void {
    if (this.model.hasServerFilter) {
      this.model.serverFilter(event.query, this.assignToFilterOptoins.bind(this));
    } else {
      this.filteredOptions = this.model.options.filter(item => this.filter(item, event.query));
    }
  }

  private assignToFilterOptoins(options: SelectableInput[]): void {
    this.filteredOptions = options;

    // HACK: If the query returns 1 value then select as the value.
    const firstOption = this.filteredOptions.length === 1 ? this.filteredOptions[0] : null;
    if (firstOption != null && firstOption.value === this.model.value) {
      this.control.setValue(firstOption);
    }

    this.changeDetector.markForCheck();
  }

  private filter = (item: SelectableInput, query: string): boolean => {
    return this.model.filter
      ? this.model.filter(item, query)
      : this.contains(item, query);
  }

  private contains(item: SelectableInput, query: string): boolean {
    return item.text.toLowerCase().indexOf(query.toLowerCase()) >= 0;
  }


  onEvent(event) {
    this.onChange.emit(event);
    this.onInput.emit(event);
  }
}
